import React from "react";
import GiftShell, { Check } from "./components/GiftShell";
import "./gift.css";

// Where the gateways send the purchaser back to after a gift payment.
// "complete": the payment is confirmed in the background (webhook), and the
// confirmation email follows. "cancelled": nothing was charged.
export default function GiftPayResult({ result }) {
  // Plain links (full page load): /my-gifts lives in the logged-in route tree.
  const loggedIn = Boolean(localStorage.getItem("access_token"));

  const actions = (
    <div className="vsr-actions">
      {loggedIn && (
        <a className="vsr-btn" href="/my-gifts">
          View My Gifts
        </a>
      )}
      <a className="vsr-btn vsr-btn-outline" href="https://verysoul.com/">
        Explore VerySoul
      </a>
    </div>
  );

  if (result === "cancelled") {
    return (
      <GiftShell>
        <div className="vsr-center">
          <section className="vsr-card vsr-reserved">
            <span className="vsr-icon-badge" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="9" />
                <line x1="12" y1="8" x2="12" y2="12.5" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </span>
            <h1 className="vsr-title">Payment not completed</h1>
            <p className="vsr-lead">You haven't been charged.</p>

            <div className="vsr-note">
              <p>
                Your recipient's session is still being held. To complete your gift, open the <b>“Complete My Gift”</b> link in the email
                we sent you and try again before the payment deadline shown there.
              </p>
            </div>

            {actions}
          </section>
        </div>
      </GiftShell>
    );
  }

  return (
    <GiftShell>
      <div className="vsr-center">
        <section className="vsr-card vsr-reserved">
          <span className="vsr-icon-badge vsr-icon-badge-success" aria-hidden="true">
            <Check />
          </span>
          <p className="vsr-eyebrow">VerySoul Gift</p>
          <h1 className="vsr-title">Thank you — your gift is on its way</h1>
          <p className="vsr-lead">We've received your payment and are confirming it now.</p>

          <ol className="vsr-next">
            <li>
              <span className="vsr-how-num">1</span>
              <span>We're confirming your payment. This usually takes just a moment.</span>
            </li>
            <li>
              <span className="vsr-how-num">2</span>
              <span>
                You'll receive an email saying your <b>VerySoul Gift is complete</b>.
              </span>
            </li>
            <li>
              <span className="vsr-how-num">3</span>
              <span>Your recipient receives their session confirmation and joining link. They chose the session so will know what was paid</span>
            </li>
          </ol>

          <blockquote className="vsr-quote">Thank you for giving someone the opportunity to explore.</blockquote>

          {actions}
        </section>
      </div>
    </GiftShell>
  );
}
